import React, { useState, useEffect } from "react";
import { db } from "../../../../assets/firebase/firebaseconfig";
import { ref, get, push, remove, update, onValue } from "firebase/database";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "../ProductManager/styles.css";
import "./styles.css";

const ProjectManager = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingProject, setEditingProject] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [quillKey, setQuillKey] = useState(0);

  // Danh sách các danh mục & khu vực (Khớp với ProjectsPage)
  const categories = [
    "Lắp đặt điều hoà trung tâm",
    "Lắp đặt điều hòa treo tường",
    "Hàn cơ khí",
    "Xây dựng",
    "Lắp đặt hệ thống điện nước",
    "Lắp đặt hệ thống năng lượng mặt trời",
    "Lắp đặt hệ thống thông gió",
  ];
  const regions = [
    "TP Hà Nội",
    "TP HCM",
    "Nha Trang",
    "Nam Định",
    "Lào Cai",
    "Thái Nguyên",
    "Đà Nẵng",
    "Nghệ An",
    "Quảng Ninh",
  ];
  const statuses = ["Đang thi công", "Đã hoàn thành", "Tạm dừng"];

  // State cho Form (Đã đổi tên trường khớp với Trang chính)
  const [formData, setFormData] = useState({
    title: "", // Khớp với project.title
    category: "", // Khớp với project.category
    region: "", // Khớp với project.region
    status: "", // Khớp với project.status
    description: "",
  });

  const [file, setFile] = useState(null);
  const CLOUD_NAME = "dseiy70jw";
  const UPLOAD_PRESET = "habakome";

  useEffect(() => {
    const projectRef = ref(db, "projects");
    onValue(projectRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        setProjects(list);
      } else {
        setProjects([]);
      }
    });
  }, []);

  const uploadMedia = async (file) => {
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", UPLOAD_PRESET);
    const res = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/upload`,
      {
        method: "POST",
        body: data,
      }
    );
    const result = await res.json();
    return result.secure_url;
  };

  const closeModal = () => {
    setShowAddModal(false);
    setEditingProject(null);
    setFormData({
      title: "",
      category: "",
      region: "",
      status: "",
      description: "",
    });
    setFile(null);
    setQuillKey((prev) => prev + 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // 1. Xử lý ảnh (Khớp với trường image)
      let imageUrl = editingProject ? editingProject.image : "";
      if (file) {
        imageUrl = await uploadMedia(file);
      }

      // 2. Chuẩn bị dữ liệu (ĐÚNG CẤU TRÚC TRANG CHỦ CẦN)
      const projectData = {
        title: formData.title,
        category: formData.category || categories[0],
        region: formData.region || regions[0],
        status: formData.status || statuses[0],
        description: formData.description,
        image: imageUrl, // Đổi từ mediaUrl thành image
        updatedAt: Date.now(),
      };

      if (editingProject && editingProject.id) {
        await update(ref(db, `projects/${editingProject.id}`), projectData);
        alert("Cập nhật thành công!");
      } else {
        await push(ref(db, "projects"), {
          ...projectData,
          createdAt: Date.now(),
        });
        alert("Thêm mới thành công!");
      }
      closeModal();
    } catch (error) {
      console.error(error);
      alert("Lỗi!");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Xác nhận xóa?")) {
      await remove(ref(db, `projects/${id}`));
    }
  };

  const filteredProjects = projects
    .filter(
      (p) =>
        p.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.region?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      const nameA = a.title || "";
      const nameB = b.title || "";
      return sortOrder === "asc"
        ? nameA.localeCompare(nameB, "vi")
        : nameB.localeCompare(nameA, "vi");
    });

  return (
    <div className="admin-content-inner">
      <div className="page-header">
        <h1>QUẢN LÝ DỰ ÁN</h1>
      </div>

      <div className="filter-section card">
        <div className="filter-bar-container">
          <div className="search-box">
            <input
              type="text"
              placeholder="Tìm tên dự án, khu vực..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="sort-box">
            <select
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              className="sort-select"
            >
              <option value="asc">A → Z</option>
              <option value="desc">Z → A</option>
            </select>
          </div>
          <button className="btn-add-new" onClick={() => setShowAddModal(true)}>
            + Thêm dự án
          </button>
        </div>
      </div>

      <div className="table-section card">
        <table className="main-table">
          <thead>
            <tr>
              <th>HÌNH ẢNH</th>
              <th>THÔNG TIN DỰ ÁN</th>
              <th>TRẠNG THÁI</th>
              <th>THAO TÁC</th>
            </tr>
          </thead>
          <tbody>
            {filteredProjects.map((item) => (
              <tr key={item.id}>
                <td>
                  <img
                    src={item.image}
                    alt="img"
                    className="table-img-preview"
                  />
                </td>
                <td>
                  <div className="info-cell">
                    <span className="main-name">{item.title}</span>
                    <span className="sub-tag">
                      {item.region} | {item.category}
                    </span>
                  </div>
                </td>
                <td>
                  <span className={`status-label ${item.status}`}>
                    {item.status}
                  </span>
                </td>
                <td>
                  <div className="action-btns">
                    <button
                      className="btn-edit-tool"
                      onClick={() => {
                        setEditingProject(item);
                        setFormData(item);
                        setShowAddModal(true);
                      }}
                    >
                      Sửa
                    </button>
                    <button
                      className="btn-delete-tool"
                      onClick={() => handleDelete(item.id)}
                    >
                      Xóa
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showAddModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>{editingProject ? "CẬP NHẬT" : "THÊM MỚI"}</h3>
              <button className="btn-close" onClick={closeModal}>
                &times;
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Tên dự án"
                  value={formData.title}
                  onChange={(e) =>
                    setFormData({ ...formData, title: e.target.value })
                  }
                  required
                />
              </div>

              <div
                style={{ display: "flex", gap: "10px" }}
                className="form-group"
              >
                <select
                  value={formData.category}
                  onChange={(e) =>
                    setFormData({ ...formData, category: e.target.value })
                  }
                  required
                  style={{ flex: 1, padding: "10px" }}
                >
                  <option value="">Chọn chuyên mục</option>
                  {categories.map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
                <select
                  value={formData.region}
                  onChange={(e) =>
                    setFormData({ ...formData, region: e.target.value })
                  }
                  required
                  style={{ flex: 1, padding: "10px" }}
                >
                  <option value="">Chọn khu vực</option>
                  {regions.map((r) => (
                    <option key={r} value={r}>
                      {r}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <select
                  value={formData.status}
                  onChange={(e) =>
                    setFormData({ ...formData, status: e.target.value })
                  }
                  required
                  style={{ width: "100%", padding: "10px" }}
                >
                  <option value="">Trạng thái dự án</option>
                  {statuses.map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Mô tả chi tiết:</label>
                <ReactQuill
                  key={quillKey}
                  theme="snow"
                  value={formData.description}
                  onChange={(val) =>
                    setFormData({ ...formData, description: val })
                  }
                />
              </div>

              <div className="form-group">
                <input
                  type="file"
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="btn-submit-form"
              >
                {loading ? "Đang xử lý..." : "LƯU DỰ ÁN"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectManager;
